module.exports = __webpack_public_path__ + "img/mb-safari.d54eac12.svg";